import { Link } from "react-router-dom";
import { ArrowLeft, Mail, Building2, Clock } from "lucide-react";
import LegalFooter from "../components/LegalFooter";

const EMAIL = "gregory@finallookapp.com";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground" data-testid="contact-page">
      <header className="px-6 py-5 border-b border-border/60 flex items-center justify-between">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
          data-testid="contact-back-link"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Link>
        <span className="brand-wordmark text-sm">FINALLOOK</span>
      </header>

      <main className="flex-1 px-6 py-10">
        <article className="max-w-2xl mx-auto space-y-8 text-sm leading-relaxed">
          <div>
            <h1 className="font-heading font-extrabold text-3xl sm:text-4xl mb-2" data-testid="contact-title">
              Contact Us
            </h1>
            <p className="text-muted-foreground" data-testid="contact-intro">
              Questions, feedback, privacy requests, or support — we're happy to help.
            </p>
          </div>

          <section
            className="rounded-2xl border border-border/60 bg-card p-6 space-y-5"
            data-testid="contact-card"
          >
            <div className="flex items-start gap-4">
              <div className="h-10 w-10 shrink-0 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                <Building2 className="h-5 w-5" />
              </div>
              <div>
                <h2 className="font-heading font-semibold text-lg mb-1">Business</h2>
                <p data-testid="contact-ownership">
                  FINALLOOK is owned and operated by{" "}
                  <span className="font-semibold text-foreground">HEAR ME NOW MUSIC GROUP LLC</span>.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="h-10 w-10 shrink-0 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                <Mail className="h-5 w-5" />
              </div>
              <div>
                <h2 className="font-heading font-semibold text-lg mb-1">Email</h2>
                <a
                  href={`mailto:${EMAIL}`}
                  className="text-primary hover:underline break-all text-base font-medium"
                  data-testid="contact-email"
                >
                  {EMAIL}
                </a>
                <p className="text-muted-foreground mt-1">
                  Use this address for general inquiries, account help, SMS or billing questions,
                  and data or privacy requests.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="h-10 w-10 shrink-0 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                <Clock className="h-5 w-5" />
              </div>
              <div>
                <h2 className="font-heading font-semibold text-lg mb-1">Response time</h2>
                <p data-testid="contact-response-time">
                  We aim to respond to all messages within 2 business days.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg mb-2">SMS &amp; opt-out</h2>
            <p>
              FINALLOOK only sends SMS messages that you explicitly approve in the app. If you have
              received a message in error or wish to stop receiving messages, reply STOP to the
              message or email us at{" "}
              <a href={`mailto:${EMAIL}`} className="text-primary hover:underline" data-testid="contact-sms-email">
                {EMAIL}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-lg mb-2">Legal</h2>
            <p>
              Read our{" "}
              <Link to="/privacy" className="text-primary hover:underline" data-testid="contact-privacy-link">
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link to="/terms" className="text-primary hover:underline" data-testid="contact-terms-link">
                Terms of Service
              </Link>
              .
            </p>
          </section>
        </article>
      </main>

      <LegalFooter />
    </div>
  );
}
